export const lookupsConstants = {
    GET_LOOKUPS_REQUEST: 'GET_LOOKUPS_REQUEST',
    GET_LOOKUPS_SUCCESS: 'GET_LOOKUPS_SUCCESS',
    GET_LOOKUPS_FAILURE: 'GET_LOOKUPS_FAILURE',

    CLEAR_LOOKUPS: 'CLEAR_LOOKUPS',
};